import { Component, computed, input, output, signal } from '@angular/core';
import { UserServiceRequestSummary } from '@core/services/service-request';
import { TitleCasePipe } from '@angular/common';
import { MdbChipsModule } from 'mdb-angular-ui-kit/chips';
import { MdbTooltipModule } from 'mdb-angular-ui-kit/tooltip';
import { RouterLink } from '@angular/router';
import { getStatusClass, getStatusDisplay } from '@shared/utilities/status.util';
@Component({
  selector: 'app-service-request-card',
  imports: [MdbChipsModule, TitleCasePipe, MdbTooltipModule, RouterLink],
  templateUrl: './service-request-card.html',
  styleUrl: './service-request-card.scss',
})
export class ServiceRequestCard {
  serviceRequests = input.required<UserServiceRequestSummary[]>();
  isLoading = input<boolean>(false);
  screenWidth = signal(typeof window !== 'undefined' ? window.innerWidth : 1024);
  isMobile = computed(() => this.screenWidth() < 768);

  //Maps for statuses from utility file
  protected readonly getStatusDisplay = getStatusDisplay;
  protected readonly getStatusClass = getStatusClass;

  protected formatServiceRequestId(serviceRequestId: number): string {
    return `SR-${serviceRequestId.toString().padStart(4, '0')}`;
  }
  protected formatServiceRequestDateTime(date: string | null): string {
    if (!date) return 'N/A';
    const parsed = new Date(date);
    const datePart = parsed.toLocaleDateString('en-US', {

      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'America/Los_Angeles'
    });
    const timePart = parsed.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/Los_Angeles'
    }).toUpperCase();
    return `${datePart}   ${timePart}`;
  }

  getServiceRequestButtonClass():string {
  return this.isMobile() ? 'btn btn-outline-dark w-100  mx-3 mb-3' : 'btn btn-floating btn-outline-dark p-4';
  }
}
